module.exports = __webpack_public_path__ + "static/media/upp_flo_pro.13bf75cf.png";